// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"14223832","453":"99dcf01f","732":"6e10d915","977":"d0d2d84d"}[chunkId] + ".chunk.js";
};